import { render, staticRenderFns } from "./VuePagination.vue?vue&type=template&id=35b422ec&scoped=true&"
import script from "./VuePagination.vue?vue&type=script&lang=js&"
export * from "./VuePagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b422ec",
  null
  
)

export default component.exports